import { localization } from '@topomatic/tap/src/l10n';

const $tr = localization.tr.bind(localization);

const AppConsts = {
    APP_GROUP_ADMINISTRATOR: 'admin',
    APP_GROUP_MY: 'my',
    APP_GROUP_SHARED: 'shared',

    APP_TASK_TRASH: 'trash',
    APP_TASK_COMPANIES: 'companies',
    APP_TASK_USERS: 'users',
    APP_TASK_CLIENTS: 'clients',
    APP_TASK_MONITORING: 'monitoring',

    FOLDER_TYPE: 'application/vnd.folder',
    DRIVE_TYPE: 'application/vnd.drive',

    PERMISSION_NONE: 0x0,
    PERMISSION_METADATA: 0x1,
    PERMISSION_COMMENT: 0x2,
    PERMISSION_READ: 0x4,
    PERMISSION_CREATE: 0x8,
    PERMISSION_UPDATE: 0x10,
    PERMISSION_DELETE: 0x20,
    PERMISSION_ADMIN: 0x40,

    permission_name(permissions) {
        if ((permissions & AppConsts.PERMISSION_ADMIN) == AppConsts.PERMISSION_ADMIN) {
            return $tr('Администратор');
        } if ((permissions & AppConsts.PERMISSION_UPDATE) == AppConsts.PERMISSION_UPDATE) {
            return $tr('Редактор');
        } if ((permissions & AppConsts.PERMISSION_READ) == AppConsts.PERMISSION_READ) {
            return $tr('Читатель');
        } if ((permissions & AppConsts.PERMISSION_COMMENT) == AppConsts.PERMISSION_COMMENT) {
            return $tr('Комментатор');
        } if ((permissions & AppConsts.PERMISSION_METADATA) == AppConsts.PERMISSION_METADATA) {
            return $tr('Метаданные');
        } if (permissions == AppConsts.PERMISSION_NONE) {
            return $tr('Без доступа');
        } if (permissions == undefined) {
            return '';
        }
        return $tr('Другое');
    },
};

AppConsts.PERMISSION_ALL = (AppConsts.PERMISSION_METADATA
    | AppConsts.PERMISSION_COMMENT
    | AppConsts.PERMISSION_READ
    | AppConsts.PERMISSION_CREATE
    | AppConsts.PERMISSION_UPDATE
    | AppConsts.PERMISSION_DELETE
    | AppConsts.PERMISSION_ADMIN);

export default AppConsts;
